module.exports = __webpack_public_path__ + "static/media/swatchvolcangreyarmy.0486edfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/swatchvolcangreyarmy.png
// module id = 629
// module chunks = 0